import { Region } from "@/gql/graphql";

export const callZones = ["americas", "emea", "asia", "oceania"] as const;

export type CallZone = (typeof callZones)[number];

/**
 * Regions bundled so each zone can be worked through in one calling session.
 * The Americas span the most, UTC-3 to UTC-8.
 */
const callZoneRegions: Record<CallZone, Region[]> = {
  americas: [Region.Us, Region.Ca, Region.Mx, Region.Sa],
  emea: [Region.Eu, Region.Sacu, Region.Me],
  asia: [Region.Jp, Region.Kr, Region.Tw],
  oceania: [Region.Au, Region.Nz, Region.Pi],
};

export function getCallZoneRegions(zones: CallZone[]): Region[] {
  return zones.flatMap((zone) => callZoneRegions[zone]);
}
